module.exports = __webpack_public_path__ + "img/portfolio--agency-04.5dad9293.jpg";